import EpDevPUtils from "../../EpDevPUtils";
import { 
  TDomainsApiBasePathParam, 
} from "../types";

const DOMAINS = "domains";

export class EpDevPDomainsApiRoutesFactory {

  public static getSubRouteBase = (): string => {
    return `/:${EpDevPUtils.nameOf<TDomainsApiBasePathParam>('organizationId')}/${DOMAINS}`;
  }
  public static getSubRouteList = (): string => { 
    return EpDevPDomainsApiRoutesFactory.getSubRouteBase();
  }
}

export class EpDevPDomainsApiPathsFactory {

  public static createListPath({ organizationId }: {
    organizationId: string;
  }): string {
    return `/${organizationId}/${DOMAINS}`;
  }

}

